import { render, staticRenderFns } from "./CRMcontent.vue?vue&type=template&id=10b25895&scoped=true&"
import script from "./CRMcontent.vue?vue&type=script&lang=js&"
export * from "./CRMcontent.vue?vue&type=script&lang=js&"
import style0 from "./CRMcontent.vue?vue&type=style&index=0&id=10b25895&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b25895",
  null
  
)

export default component.exports